import type { Story } from '@/store/story-types'

export const DIGITAL_PRODUCTS_STORE_STORY: Story = {
  id: 'digital-products-store',
  name: 'Digital Products Store',
  narrative:
    'A digital downloads store for creators selling courses, templates, and design assets with testimonials and a streamlined cart experience.',
  goals: [
    'Present digital products in an organized grid',
    'Build credibility through customer testimonials',
    'Enable instant digital product purchases',
    'Provide a simple cart and checkout flow',
  ],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home',
      title: 'Home',
      order: 0,
      status: 'draft',
      elementCount: 4,
      linkedPageId: 'home',
      description:
        'Landing page with hero banner, products grid, and testimonials section',
      blockRef: { category: 'store', blockId: 'digital-hero' },
    },
    {
      id: 'pg-cart',
      title: 'Cart',
      order: 1,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'cart',
      description: 'Shopping cart with digital items and order total',
      blockRef: { category: 'store', blockId: 'cart-view' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-browse',
      name: 'Browse Digital Products',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        {
          type: 'then',
          text: 'the hero banner, products grid with categories, and testimonials are visible',
          linkedPageId: 'home',
        },
      ],
    },
    {
      id: 'bdd-add-to-cart',
      name: 'Add Digital Product to Cart',
      steps: [
        { type: 'given', text: 'the visitor is browsing the products grid' },
        { type: 'when', text: 'the visitor taps "Add to Cart" on a product card' },
        {
          type: 'then',
          text: 'the digital product is added to the cart and the cart badge updates',
          linkedPageId: 'cart',
        },
      ],
    },
    {
      id: 'bdd-checkout',
      name: 'Purchase Digital Products',
      steps: [
        { type: 'given', text: 'the visitor has digital products in the cart' },
        { type: 'when', text: 'the visitor taps "Checkout" and completes payment' },
        {
          type: 'then',
          text: 'the purchase is confirmed and download links are provided',
          linkedPageId: 'cart',
        },
      ],
    },
  ],
}
